<template>
  <Toast position="bottom-right" />
  <Suspense>
    <router-view />
  </Suspense>
</template>
<script setup lang="ts">
import Toast from "primevue/toast";
</script>
